import { Text } from "@ttc3k/trekker";
import { useBookerContext, useCartContext } from "widgets/booker/contexts";
import { UpsellSelectionCard, CollapsableStep } from "widgets/booker/shared";
import { useTranslation } from "react-i18next";
import { formatPrice, getResolvedProductSellingConfig } from "shared/utils";
import { SimpleFlag } from "shared/components";
import { useMemo } from "react";

export const Purchase = () => {
  const { cart, updateCartItem } = useCartContext();
  const { product } = useBookerContext();
  const sellingConfig = useMemo(
    () => getResolvedProductSellingConfig(product as typeof product & { sellingConfig?: any }),
    [product],
  );

  const { t } = useTranslation("booker", { keyPrefix: "PURCHASE" });
  const mainCartItem = useMemo(() => cart[0], [cart]);
  const quantity = useMemo(() => mainCartItem?.quantity ?? 1, [mainCartItem]);

  const handleQuantityChange = (quantity: number) => {
    updateCartItem(mainCartItem.productId, { quantity });
  };

  if (
    !sellingConfig.quantity?.enabled ||
    sellingConfig.quantity.maxQuantity === 1
  ) {
    return null;
  }

  return (
    <CollapsableStep
      title={t("TITLE")}
      complete={quantity > 0}
      stepId="purchase"
    >
      <Text color="text.mid">{t("SUBTITLE")}</Text>
      <UpsellSelectionCard
        mainText={t("TITLE")}
        subText={`$${formatPrice(sellingConfig.basePrice)}`}
        onQuantityChange={v => handleQuantityChange(v)}
        maxQuantity={sellingConfig.quantity?.maxQuantity ?? undefined}
        minQuantity={1} // Add a minimum quantity of 1 to prevent the user from selecting 0 quantity of the main product
        quantityEnabled={sellingConfig.quantity?.enabled}
        quantity={quantity}
      />
      {sellingConfig.quantity?.maxQuantity && (
        <SimpleFlag
          text={t("MAX_QUANTITY", {
            count: sellingConfig.quantity.maxQuantity,
          })}
        />
      )}
    </CollapsableStep>
  );
};
